<template>
  <div class="animated fadeIn">
    <div>
      <b-row> </b-row>
      <b-row>
        <b-col>
          <b-img :src="img" left fluid style="max-height: 120px" alt="Responsive image" class="rounded pb-0"></b-img>
          <h1 class="text-right">INFORME DE INSPECCIÓN LOTE #{{ objReportQc.lot.number }}</h1>
          <p class="text-right">
            {{ dataLote[1].toUpperCase() }}-{{ dataLote[2].toUpperCase() }} <br />
            {{ dataLote[3].toUpperCase() }} <br />
            TIPO INSPECCIÓN: {{ objReportQc.inspection_type_name }} <br />
            FECHA INSPECCIÓN: {{ objReportQc.created_at | moment }}
          </p>
          <!--       <a href="#" class="float-right text-black-50"  @click="printDiv"><i class="fa fa-print"></i></a>&nbsp;&nbsp; -->
          <a
            :href="DirLaravel + 'controlcalidad/imprimirEvaluacion/' + parameters"
            target="_blank"
            class="float-right text-black-50"
            ><i class="fa fa-download"></i
          ></a>

          <!--  <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a> -->
        </b-col>
      </b-row>

      <h5 class="border-bottom border-secondary pb-2 text-center text-uppercase">PLANILLA INSPECCIÓN</h5>
      <div v-if="objReportQc.inspection_type == 1">
        <b-row class="mb-4">
          <b-col sm="6">
            <b>GUIA: </b> {{ objectInspection.dataInformationInspection.guia }} <br />
            <b>EXPORTADORA: </b> {{ objectInspection.dataInformationInspection.exportadora }} <br />
            <b>EMPRESA: </b> {{ objectInspection.dataInformationInspection.empresa }} <br />
            <b>TAMAÑO MUESTRA: </b> {{ objectInspection.dataInformationInspection.muestra }} <br />
            <b>N° REJILLAS: </b> {{ objectInspection.dataInformationInspection.numero_rejillas }} <br />
            <b>TIPO REJILLA: </b> {{ objectInspection.dataInformationInspection.tipo_rejilla }} <br />
            <b>PALLET: </b> {{ objectInspection.dataInformationInspection.pallet }} <br />
            <b>OBSERVACION: </b> {{ objectInspection.dataInformationInspection.observation }} <br />
          </b-col>
          <b-col sm="6">
            <b>FECHA COSECHA: </b>{{ objectInspection.dataInformationInspection.fecha_cosecha }} <br />
            <b>PATENTE TRANSPORTE: </b> {{ objectInspection.dataInformationInspection.patente_transporte }} <br />
            <b>CONDICIÓN TRANSPORTE: </b> {{ objectInspection.dataInformationInspection.condicion_trasporte }} <br />
            <b>CONDICIÓN DE LA CARGA: </b> {{ objectInspection.dataInformationInspection.condicion_carga }} <br />
            <b>T° TRANSPORTE: </b> {{ objectInspection.dataInformationInspection.temperatura_transporte }} <br />
            <b>T° PULPA: </b> {{ objectInspection.dataInformationInspection.temperatura_pulpa }} <br />
            <b>BRIX: </b> {{ objectInspection.dataInformationInspection.brix }} <br />
            <b>BAXLO: </b> {{ objectInspection.dataInformationInspection.baxlo }} <br />
          </b-col>
        </b-row>
      </div>
      <div v-if="objReportQc.inspection_type == 2">
        <b-row class="mb-4">
          <b-col sm="6">
            <b>GUIA: </b> {{ objectInspection.dataInformationInspection.guia }} <br />
            <b>EXPORTADORA: </b> {{ objectInspection.dataInformationInspection.exportadora }} <br />
            <b>EMPRESA: </b> {{ objectInspection.dataInformationInspection.empresa }} <br />
            <b>TAMAÑO MUESTRA: </b> {{ objectInspection.dataInformationInspection.muestra }} <br />
            <b>NUMERO PROCESO:</b>{{ objectInspection.dataInformationInspection.numero_proceso }} <br />
            <b>PALLET: </b> {{ objectInspection.dataInformationInspection.pallet }} <br />
            <b>OBSERVACION: </b> {{ objectInspection.dataInformationInspection.observation }} <br />
          </b-col>
          <b-col sm="6">
            <b>BRIX: </b> {{ objectInspection.dataInformationInspection.brix }} <br />
            <b>BAXLO: </b> {{ objectInspection.dataInformationInspection.baxlo }} <br />
          </b-col>
        </b-row>
      </div>
      <hr />
      <b-row class="mb-0">
        <b-col lg="12">
          <template v-for="(item, index) in objectInspection.resulDefectType">
            <h5 class="mb-3 font-weight-bold">{{ item.datosTipoDefecto.nombreTipoDefecto }}</h5>
            <div class="table-responsive-sm" :key="index">
              <table class="table table-sm">
                <thead>
                  <tr class="font-weight-bold text-uppercase">
                    <th class="align-middle">Defecto</th>
                    <th class="text-center">Existe/Peso(gr)</th>
                    <th class="text-center">%</th>
                    <th class="text-center">Tolerancia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(defectdata, defectIndex) in item.dataDefect" :key="defectIndex">
                    <template v-if="defectdata.defecto_suma == 0">
                      <td class="left align-middle">{{ defectdata.nombreDefecto }}</td>
                      <td class="text-center">{{ defectdata.peso }}</td>
                      <td class="text-center">{{ defectdata.porcentaje }}</td>
                      <td class="text-center">
                        <b-badge href="" :style="'color:white;background-color:' + defectdata.color">{{
                          defectdata.clasificacion
                        }}</b-badge>
                      </td>
                    </template>

                    <template v-if="defectdata.defecto_suma == 1">
                      <td class="left align-middle">{{ defectdata.nombreDefecto }}</td>
                      <td class="text-center">{{ defectdata.peso == 1 ? "SI" : "NO" }}</td>
                      <td class="text-center">N/A</td>
                      <td class="text-center">
                        <b-badge href="" :style="'color:white;background-color:' + defectdata.color">{{
                          defectdata.clasificacion
                        }}</b-badge>
                      </td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="font-weight-bold">
                    <td class="text-center">Sumatoria {{ item.datosTipoDefecto.nombreTipoDefecto }}</td>
                    <td class="text-center">{{ item.datosTipoDefecto.peso }}</td>
                    <td class="text-center">{{ item.datosTipoDefecto.porcentaje }}</td>
                    <td class="text-center">
                      <b-badge href="" :style="'color:white;background-color:' + item.datosTipoDefecto.color">{{
                        item.datosTipoDefecto.clasificacion
                      }}</b-badge>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </template>

          <h5 class="mb-3 font-weight-bold">Resultado Inspección</h5>
          <div class="table-responsive-sm">
            <table class="table table-sm">
              <thead>
                <tr class="font-weight-bold text-uppercase">
                  <th class="text-center">Peso(gr)</th>
                  <th class="text-center">%</th>
                  <th class="text-center">Tolerancia</th>
                </tr>
              </thead>
              <tbody>
                <tr class="font-weight-bold">
                  <td class="text-center">{{ objectInspection.resulInspeccion.peso }}</td>
                  <td class="text-center">{{ objectInspection.resulInspeccion.porcentaje }}</td>
                  <td class="text-center">
                    <b-badge
                      href=""
                      :style="'color:white;background-color:' + objectInspection.resulInspeccion.color"
                      >{{ objectInspection.resulInspeccion.clasificacion }}</b-badge
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <h5 class="mb-3 font-weight-bold">Resultado Imagenes</h5>
      <b-container fluid class="p-4">
        <b-row>
          <b-col v-for="(imgData, imgIndex) in objectInspection.imgInspections" :key="imgIndex">
            <b-img thumbnail fluid :src="'' + DirLaravel + 'img/' + imgData.nombre" alt="Image"></b-img>
          </b-col>
        </b-row>
      </b-container>
      <template>
        <h5 class="mb-3 font-weight-bold">Control Peso</h5>
        <div class="table-responsive-sm">
          <table class="table table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="align-middle">Peso deseado</th>
                <th class="align-middle">Peso Observado</th>
                <th class="align-middle">Fecha</th>
                <th class="text-center">Foto</th>
                <th class="left align-middle">Observacion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in objectInspection.controlPesos.Pesos">
                <template>
                  <td class="left align-middle">{{ item.peso_deseado }}</td>
                  <td class="center align-middle">{{ item.peso_observado }}</td>
                  <td class="left align-middle">{{ item.fecha_control }}</td>
                  <td class="text-center" v-if="item.foto != ''">
                    <b-img
                      width="150px"
                      height="150px"
                      thumbnail
                      fluid
                      :src="'' + DirLaravel + 'img/' + item.foto"
                      alt="Image"
                    ></b-img>
                  </td>
                  <td class="text-center" v-else>SIN IMAGEN</td>
                  <td class="left align-middle">{{ item.observacion }}</td>
                </template>
              </tr>
            </tbody>
          </table>
          <p>
            Promedio peso observado: {{ objectInspection.controlPesos.promedio }}
            <br />
            Porcentaje bajo peso: {{ objectInspection.controlPesos.porcentajebajopeso }} %
          </p>
        </div>
      </template>
      <template>
        <h5 class="mb-3 font-weight-bold">Control Etiqueta</h5>
        <div class="table-responsive-sm">
          <table class="table table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="align-middle">csg/csp/ggn</th>
                <th class="left align-middle">variedad</th>
                <th class="left align-middle">Fecha</th>
                <th class="left align-middle">Fecha Control</th>
                <th class="left align-middle">Evaluacion</th>
                <th class="text-center">Foto</th>
                <th class="left align-middle">Observacion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in objectInspection.controlEtiqueta">
                <template>
                  <td class="left align-middle">{{ item.csg }} / {{ item.csp }} / {{ item.ggn }}</td>
                  <td class="left align-middle">{{ item.variedad }}</td>
                  <td class="left align-middle">{{ item.fecha }}</td>
                  <td class="left align-middle">{{ item.fecha_control }}</td>
                  <td class="left align-middle">{{ item.evaluacion }}</td>
                  <td class="text-center" v-if="item.foto != ''">
                    <b-img
                      width="150px"
                      height="150px"
                      thumbnail
                      fluid
                      :src="'' + DirLaravel + 'img/' + item.foto"
                      alt="Image"
                    ></b-img>
                  </td>
                  <td class="text-center" v-else>SIN IMAGEN</td>
                  <td class="left align-middle">{{ item.observacion }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";

export default {
  name: "ReporQC",
  created() {},
  props: ["objReportQc"],
  data() {
    return {
      parameters: "",
      dataLote: [],
      arrayImageInspection: [],
      //DirLaravel:"http://192.168.0.13/packingonline/public/",
      DirLaravel: localStorage.getItem("qc_api_url"),
      img: "",
      objectInspection: {},
      current_date: moment(new Date()).format("DD-MM-YYYY HH:mm")
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    decimal: function (value) {
      let v = parseFloat(value).toFixed(2);
      return numeral(v).format("0,0.00");
    }
  },
  computed: {},

  methods: {
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open("", "", "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0");
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    loadDataInspection: function () {
      this.$axios
        .get(
          "" +
            this.DirLaravel +
            "controlcalidad/get_data_inspection_lote/" +
            this.objReportQc.inspection +
            "/" +
            this.objReportQc.inspection_type +
            "/" +
            this.objReportQc.lot.id
        )
        .then((res) => {
          this.objectInspection = res.data;

          var porciones = this.objectInspection.dataInformationInspection.numero_lote.split("-");
          this.dataLote = porciones;
        })
        .catch((error) => {
          console.log(error.response);
        });
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");

    var porciones = this.img.split("/");
    this.parameters = this.objReportQc.inspection + "/" + porciones[2];
  },
  beforeMount() {}
};
</script>

<style>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
